import apiClient from './client';
import type { MenuItem, CreateMenuItemInput, UpdateMenuItemInput, ReorderMenuItem } from '@/types/menu';

// Obter menu do usuário (filtrado por permissões)
export const getUserMenu = async (): Promise<MenuItem[]> => {
    const response = await apiClient.get<MenuItem[]>('/menus');
    return response.data;
};

// Obter todos os itens de menu (admin)
export const getAllMenuItems = async (): Promise<MenuItem[]> => {
    const response = await apiClient.get<MenuItem[]>('/menus/all');
    return response.data;
};

// Criar item de menu
export const createMenuItem = async (data: CreateMenuItemInput): Promise<MenuItem> => {
    const response = await apiClient.post<MenuItem>('/menus', data);
    return response.data;
};

// Atualizar item de menu
export const updateMenuItem = async (
    itemId: number,
    data: UpdateMenuItemInput
): Promise<MenuItem> => {
    const response = await apiClient.put<MenuItem>(`/menus/${itemId}`, data);
    return response.data;
};

// Excluir item de menu
export const deleteMenuItem = async (itemId: number): Promise<{ message: string }> => {
    const response = await apiClient.delete<{ message: string }>(`/menus/${itemId}`);
    return response.data;
};

// Reordenar itens de menu
export const reorderMenuItems = async (
    items: ReorderMenuItem[]
): Promise<{ message: string }> => {
    const response = await apiClient.patch<{ message: string }>('/menus/reorder', { items });
    return response.data;
};
